import { canShowFatcaCrs } from "./canShowFatcaCrs";

/**
 * Whether the per-contact "act on behalf" delegation toggle should be offered. Gated by
 * `contacts-read-only`: delegation only means something where contacts are read-only by default,
 * so with the flag off every contact can already write and the toggle has nothing to grant.
 * When FATCA/CRS is active for the fund ({@link canShowFatcaCrs}), the toggle is also shown so
 * admins can grant write access and collect per-contact KYC on act-on-behalf contacts.
 *
 * Note: `getCompanyInfo` only projects enabled features (as `true`) into the `features` map, so
 * a disabled flag is indistinguishable from a not-yet-loaded map by looking at the value alone.
 * Callers that need to defer gating until the map is populated pair this with a separate loading
 * signal (e.g. `isLoadingCompanyInfo` from `useCompanyContext`).
 */
export const canShowActOnBehalf = (features: { [key: string]: boolean }, isFundRegistry: boolean): boolean =>
  features["contacts-read-only"] === true || canShowFatcaCrs(features, isFundRegistry);
